var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento venduto...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { "margin-bottom": "50px" }, attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { margin: "24px 24px 0px 24px" },
                  attrs: { xs12: "" },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "padding-right": "10px" },
                          attrs: { cols: "5" },
                        },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Stagione",
                              items: _vm.stagioni,
                              "item-value": "id",
                              "item-text": "id",
                              "data-test": "lista-stagioni",
                            },
                            model: {
                              value: _vm.stagione,
                              callback: function ($$v) {
                                _vm.stagione = $$v
                              },
                              expression: "stagione",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.userIsAdmin
                        ? _c(
                            "v-col",
                            [
                              _c("v-select", {
                                attrs: {
                                  filled: "",
                                  clearable: "",
                                  "return-object": "",
                                  items: _vm.fornitori,
                                  "item-text": "nome",
                                  label: "Fornitori",
                                  hint: "Selezionare un fornitore per visualizzare i dati",
                                },
                                model: {
                                  value: _vm.fornitore,
                                  callback: function ($$v) {
                                    _vm.fornitore = $$v
                                  },
                                  expression: "fornitore",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "padding-right": "10px" },
                          attrs: { cols: "5" },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Modello",
                              "item-value": "id",
                            },
                            model: {
                              value: _vm.modello,
                              callback: function ($$v) {
                                _vm.modello = $$v
                              },
                              expression: "modello",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              clearable: "",
                              label: "Zona",
                              "item-value": "id",
                            },
                            model: {
                              value: _vm.zona,
                              callback: function ($$v) {
                                _vm.zona = $$v
                              },
                              expression: "zona",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { justify: "end" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: "primary",
                            large: "",
                            disabled: !_vm.canSearchVenduto,
                            "data-test": "caricaPaginaVenduto",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.caricaPaginaVenduto(1)
                            },
                          },
                        },
                        [
                          _vm._v(" Cerca "),
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-refresh"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.venduto && _vm.venduto.length > 0
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            color: "white",
                            "margin-top": "10px",
                            "margin-left": "24px",
                          },
                          attrs: {
                            loading: _vm.csvButtonLoading,
                            color: "green lighten-2",
                          },
                          on: { click: _vm.downloadCSVVenduto },
                        },
                        [
                          _vm._v(" Scarica CSV "),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                        ],
                        1
                      ),
                      _c("VendutoList", { attrs: { venduto: _vm.venduto } }),
                    ],
                    1
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: { margin: "auto 10px" },
                          attrs: { type: "info", value: true },
                        },
                        [
                          _vm._v(
                            "Non ci sono dati sul venduto da visualizzare."
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
              _vm.canSearchVenduto
                ? _c("div", { staticClass: "pagination text-xs-center" }, [
                    _c("div", { staticClass: "pagination-text grey--text" }, [
                      _vm._v(" Elementi visualizzati: "),
                      _c("strong", [_vm._v(_vm._s(_vm.numTotVenduti))]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "pagination-buttons" },
                      [
                        _c("v-pagination", {
                          attrs: {
                            length: _vm.pageCount,
                            disabled: _vm.loading,
                          },
                          model: {
                            value: _vm.page,
                            callback: function ($$v) {
                              _vm.page = $$v
                            },
                            expression: "page",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }